var thelink = jQuery('.active-menu-link').first();
//check if it's a parent item
  if(jQuery(thelink).hasClass('nochild')){
    var theparent = jQuery(thelink).parent().parent();
    var thesubmenu = jQuery(theparent).find('ul');
    console.log('the parent is'+ jQuery(theparent).find('button .mobile-nav__label').first().text());
  }
  else{
    if(jQuery(thelink).find('button .mobile-nav__label').length>0){
      console.log('this is the link'+jQuery(thelink).find('button .mobile-nav__label').first().text());
      var thesubmenu = jQuery(thelink).find('ul');
    }
    else{
    console.log('this is the link'+jQuery(thelink).find('.mobile-nav__label').text());
    var thesubmenu = '';
    }   
  }
  var thedropdown = document.createElement('select');
  thedropdown.id = 'subnav-dropdown';
  jQuery(thedropdown).append('<option value="">Product Type</option>');
  var thedropdownitemscounter = 0;
  jQuery(thesubmenu).find('li').each(function(){
    if(jQuery(this).find('a').attr('href')){
      var theoptionlabel = jQuery(this).find('.mobile-nav__label').text();
      if(thedropdownitemscounter == 0){
        theoptionlabel = "Show All";
      }
  jQuery(thedropdown).append('<option value="'+jQuery(this).find('a').attr('href')+'">'+theoptionlabel+'</option>');
     thedropdownitemscounter ++;  
    }
     
  });
    jQuery(thedropdown).addClass('filters-toolbar__input');
   
   jQuery('#collections-sub-menu-wrapper-inner').prepend(thedropdown);
   jQuery('#collections-sub-menu').prepend('<label class="filters-toolbar__label select-label" for="SortBy">Filter by type</label>');
  jQuery('#subnav-dropdown, #FilterTagsProductType').each(function(){
     jQuery(this).on('change',function(){
    var theurl = jQuery(this).find('option:selected').val();
  	window.location.href = theurl;
 	 });
  });
  